import React from 'react';
import type { BenefitItem } from '../types';

type Props = {
  benefits: BenefitItem[];
};

export default function Features({ benefits }: Props) {
  return (
    <section id="features" className="bg-white/[0.03] py-24 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm uppercase tracking-[0.22em] text-[hsl(var(--landing-accent-foreground))]">Features</p>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-white md:text-5xl">
            Built around control, clarity, and trust
          </h2>
          <p className="mt-4 text-lg leading-8 text-white/75">
            Each piece exists for a simple reason: to keep you in control of your brand and to make
            sure value is shared only when it has actually been created.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {benefits.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.title}
                className="rounded-[30px] border border-white/10 bg-slate-900/70 p-8 text-white backdrop-blur transition hover:border-[hsl(var(--landing-accent-ring)/0.3)] hover:bg-slate-900"
              >
                <div className="mb-5 inline-flex rounded-2xl bg-[hsl(var(--landing-accent-ring)/0.1)] p-3 ring-1 ring-[hsl(var(--landing-accent-ring)/0.2)]">
                  <Icon className="h-5 w-5 text-[hsl(var(--landing-accent-foreground))]" />
                </div>
                <h3 className="text-xl font-semibold tracking-tight text-white">{benefit.title}</h3>
                <p className="mt-3 leading-7 text-white/80">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
